var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('oie-base-button',{attrs:{"css-classes":"button--with-border button--blue checkout-next-step","text":_vm.text,"disabled":_vm.disabled},on:{"click":_vm.nextStep}})}
var staticRenderFns = []

export { render, staticRenderFns }